import React, {useState} from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import './i18n/i18n';
import './dxf-fixes.scss';
import {dynamicConfig} from './init/config';
import {t} from 'i18next';
import {
    getDownloadServiceNotEnabledErrorMessage,
    getErrorDataValidationMessages
} from './components/errors/ErrorRegister';
import {ErrorDialogue} from './components/errors/ErrorDialogue';

if (process.env.REACT_APP_DXF_DOWNLOAD_INCLUDE_FROK) {
    require('./index.scss');
}

const DownloadServicePreLoad = () => {
    const [populateError, setPopulateError] = useState<boolean>(true);
    if (!dynamicConfig.DLS_ENABLED) {
        let errorData = getErrorDataValidationMessages(t('ERROR_LOADING_FAILED'), getDownloadServiceNotEnabledErrorMessage());
        return <ErrorDialogue populate={populateError}
                              headline={errorData?.headline}
                              description={errorData?.errorDescription}
                              onChange={(populated: boolean) => setPopulateError(populated)}/>
    } else {
        return (
            <App/>
        );
    }
};

ReactDOM.render(
    <React.StrictMode>
        {<DownloadServicePreLoad/>}
    </React.StrictMode>,
    document.getElementById('download-center-frontend')
);